import { FileOutlined, LinkOutlined } from "@ant-design/icons";
import { Descriptions, Spin } from "antd";
import { useContext, useEffect, useState } from "react";
import { Link, Navigate, useNavigate, useParams } from "react-router-dom";
import axiosInstance from "../common/api";
import { date2locale, formatDateTime, toLocaleString } from "../common/common";
import PdfViewer from "../common/PdfViewer";
import Toolbar from "../common/Toolbar";
import { UserInfoContext } from "../FetchUserInfo";

export default function () {
    const [data, setData] = useState({});
    const [loading, setLoading] = useState(false);
    const [paycheckUrl, setPaycheckUrl] = useState();
    const { id } = useParams();
    const navigate = useNavigate();
    const userInfo = useContext(UserInfoContext);

    const fetchData = () => {
        setLoading(true);
        axiosInstance
            .get(`charge/${id}`)
            .then(({ data }) => setData(data))
            .finally(() => setLoading(false));
    };
    useEffect(fetchData, []);

    return (
        <Spin spinning={loading}>
            <PdfViewer url={paycheckUrl} onClose={() => setPaycheckUrl(null)} />
            <Toolbar
                topDivider={false}
                editAction={
                    userInfo.permissions?.includes("charge.update") ? () => navigate("edit") : null
                }
                selectedKeys={[1]}
                deleteAction={
                    userInfo.permissions?.includes("charge.delete")
                        ? () => axiosInstance.delete(`/charge/${id}`).then(() => navigate(-1))
                        : null
                }
            />
            <Descriptions layout="vertical" colon={false} size="small">
                <Descriptions.Item label="ID">{data.id}</Descriptions.Item>
                <Descriptions.Item label="Descrizione">{data.description}</Descriptions.Item>
                <Descriptions.Item label="Data">{date2locale(data.date)}</Descriptions.Item>
                <Descriptions.Item label="Dipendente">{data.employee?.fullName}</Descriptions.Item>
                <Descriptions.Item label="Importo">
                    {toLocaleString(data.amount ?? 0)}
                </Descriptions.Item>
                <Descriptions.Item label="Multa collegata">
                    {data.fine?.id && (
                        <Link to={`/fines/${data.fine?.id}`}>
                            <u>
                                {data.fine?.id}
                                <LinkOutlined style={{ marginLeft: 5 }} />
                            </u>
                        </Link>
                    )}
                </Descriptions.Item>
                <Descriptions.Item label="Cedolino addebitato">
                    {data.chargedPaycheck?.id && (
                        <Link
                            onClick={() =>
                                setPaycheckUrl(`/paycheck/${data.chargedPaycheck.id}/file`)
                            }
                        >
                            <u>
                                {`${data.chargedPaycheck?.period} ${data.chargedPaycheck?.year}`}
                                <FileOutlined style={{ marginLeft: 5 }} />
                            </u>
                        </Link>
                    )}
                </Descriptions.Item>
                <Descriptions.Item label="Creato da">{data.createdBy?.fullName}</Descriptions.Item>
                <Descriptions.Item label="Data creazione">
                    {formatDateTime(data.creationTs)}
                </Descriptions.Item>
            </Descriptions>
        </Spin>
    );
}
